import { DateTime } from 'luxon';

export function generateInitialTimeStamp({
  timeUnit,
  candleDuration,
  currentCandle,
  millisBetweenCandles,
}) {
  if (timeUnit === 'MINUTES') {
    const newNextTimeStamp = currentCandle.timeStamp + millisBetweenCandles;
    return newNextTimeStamp;
  }
  if (timeUnit === 'DAYS') {
    const newNextTimeStamp = DateTime.fromMillis(currentCandle.timeStamp)
      .setZone('America/New_York')
      .plus({
        days: candleDuration,
      })
      .toMillis();
    return newNextTimeStamp;
  }
  if (timeUnit === 'WEEKS') {
    const newNextTimeStamp = DateTime.fromMillis(currentCandle.timeStamp)
      .setZone('America/New_York')
      .plus({
        weeks: candleDuration,
      })
      .toMillis();
    return newNextTimeStamp;
  }
  if (timeUnit === 'MONTHS') {
    const newNextTimeStamp = DateTime.fromMillis(currentCandle.timeStamp)
      .setZone('America/New_York')
      .plus({
        months: candleDuration,
      })
      .toMillis();
    return newNextTimeStamp;
  }
  if (timeUnit === 'YEARS') {
    const newNextTimeStamp = DateTime.fromMillis(currentCandle.timeStamp)
      .setZone('America/New_York')
      .plus({
        years: candleDuration,
      })
      .toMillis();
    return newNextTimeStamp;
  }
}
